import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { Sinvoice } from '../entities/s-invoice';


export class SinvoiceRequest extends BaseRequest {
    sinvoice : Sinvoice;
}
